import "./css/app.css"
import React from "react"
import { createRoot } from "react-dom/client"

import Routing from "./Routing"

const root: HTMLElement | null = document.getElementById("root")
if (root) {
    createRoot(root).render(<Routing />)
}
